export const colors = {
  primary: "#1790FF",
  primaryHovered: "#26B1FF",
  placeHolder: "#697587",
  background: "#EBECED",
}